import api from "./api";

const VehicleReadingService = {
  //  CREATE a new vehicle reading
  create: async (data) => {
    const response = await api.post("/vehicleReading/save", data);
    return response.data;
  },

  checkExisting: async (vehicleId, readingDate, companyId) => {
    const response = await api.get("/vehicleReading/check-existing", {
      params: { vehicleId, readingDate, companyId }
    });
    return response.data;
  },

  checkLastCompleted: async (vehicleId, projectId, companyId, excludeReadingId = null) => {
    const response = await api.get("/vehicleReading/check-last-completed", {
      params: { vehicleId, projectId, companyId, excludeReadingId }
    });
    return response.data;
  },

  //  GET all vehicle readings
  getAll: async () => {
    const response = await api.get("/vehicleReading/get");
    return response.data;
  },

  //  GET only active vehicle readings
  getActive: async () => {
    const response = await api.get("/vehicleReading/status/active/list");
    return response.data;
  },

  //  GET single vehicle reading by ID
  getById: async (id) => {
    const response = await api.get(`/vehicleReading/getById/${id}`);
    return response.data;
  },

  // UPDATE vehicle reading by ID
  update: async (id, data) => {
    const response = await api.put(`/vehicleReading/update/${id}`, data);
    return response.data;
  },

  //  DELETE vehicle reading by ID (hard delete)
  delete: async (id) => {
    const response = await api.delete(`/vehicleReading/${id}`);
    return response.data;
  },

  //  TOGGLE STATUS (active <-> inactive)
  updateStatus: async (id) => {
    const response = await api.put(`/vehicleReading/updatestatus/${id}`);
    return response.data;
  },

  // getByCompanyId: async (companyId) => {
  //   const response = await api.get(
  //     `/vehicleReading/getByCompany/${companyId}`
  //   );
  //   return response.data;
  // },

  getByCompanyId: async (companyId, pageNumber, noOfRows, projectId = "", search = "", fromDate = "", toDate = "", employeeId = "", roleId = "") => {
    const response = await api.get(
      `/vehicleReading/getByCompany/${companyId}`, {
        params: {
          pageNumber,
          noOfRows,
          projectId,
          search,
          fromDate,
          toDate,
          employeeId,
          roleId
        }
      }
    );
    return response.data;
  },

  exportVehicleReading: async (companyId, projectId = "", search = "", fromDate = "", toDate = "", employeeId = "", roleId = "") => {
    const response = await api.get(
      `/vehicleReading/export`, {
        params: {
          companyId,
          projectId,
          search,
          fromDate,
          toDate,
          employeeId,
          roleId
        }
      }
    );
    return response.data;
  },

};

export default VehicleReadingService;
